<template>
    <div>
        <div class="dekstop-view">
            <div class="tableFixHead sticky2">
                <table>
                    <thead>
                        <tr>
                            <th @click="clickThead(index)" style="cursor:pointer" v-for="(item, index) in th" :key="index" :style="loadStyle(index)">
                                <CRow class="no-gutters">
                                    <CCol sm="11">
                                        <span>{{item}}</span>
                                    </CCol>
                                    <CCol sm="1">
                                        <img :src="sortIcon[index]" width="8px" height="16px" style="float:right"/>
                                    </CCol>
                                </CRow>
                            </th>
                        </tr>
                    </thead>
                </table>
            </div>
            <div class="content-sticky">
                <CRow>
                    <CCol sm="12">
                        <div class="tableFixHead">
                            <table>
                                <tbody v-if="data.length == 0">
                                    <tr>
                                        <td class="text-center" colspan="5">
                                            {{errors}}
                                        </td>
                                    </tr>
                                </tbody>
                                <tbody v-else>
                                    <tr v-for="(body, id) in data" :key="id" @click="goEdit(id)" style="cursor:pointer">
                                        <td v-for="(item, index) in td" :key="index" :style="loadStyle(index)">
                                            <template v-if="item != 'action'">
                                                <template v-if="item[0].length == 1">
                                                    <template v-if="item == 'hargaSatuan'">
                                                        {{rupiahMode(body[item])}}
                                                    </template>
                                                    <template v-else>
                                                        <template v-if="item == 'statusPengadaan'">
                                                            <span v-if="body[item] == 'N'" class="text-danger">Belum Pengadaan</span>
                                                            <span v-if="body[item] == 'Y'" class="text-success">Sudah Pengadaan</span>
                                                        </template>
                                                        <template v-else>
                                                            <template v-if="item == 'modified'">
                                                                <CRow v-if="body['modifiedBy'] != '' && body['modifiedAt'] != ''">
                                                                    <CCol sm="12">
                                                                        <span v-if="body['modifiedBy'] != ''">Oleh {{body['modifiedBy']}}</span>
                                                                        <span v-if="body['modifiedBy'] == ''">-</span>
                                                                    </CCol>
                                                                    <CCol sm="12">
                                                                        <span v-if="body['modifiedAt'] != ''">Pada {{body['modifiedAt']}}</span>
                                                                        <span v-if="body['modifiedAt'] == ''">-</span>
                                                                    </CCol>
                                                                </CRow>
                                                                <CRow v-else>
                                                                    -
                                                                </CRow>
                                                            </template>
                                                            <template v-else>
                                                                <span v-if="body[item] != ''" :title="body[item]">{{body[item]}}</span>
                                                                <span v-else>-</span>
                                                            </template>
                                                        </template>
                                                    </template>
                                                </template>
                                                <template v-if="item[0].length != 1">
                                                    <template v-if="item[0] == 'tanggalMulaiKontrak'">
                                                        <span v-if="body[item[0]] != ''" :title="body[item[0]]">{{body[item[0]]}}</span><span v-else>-</span> - <span v-if="body[item[1]] != ''" :title="body[item[1]]">{{body[item[1]]}}</span><span v-else>-</span>
                                                    </template>
                                                    <template v-else>
                                                        <CRow>
                                                            <CCol sm="12">
                                                                <div class="ellps">
                                                                    <span v-if="body[item[0]] != ''" :title="body[item[0]]">{{body[item[0]]}}</span>
                                                                    <span v-else>-</span>
                                                                </div>
                                                            </CCol>
                                                            <CCol sm="12">
                                                                <div>
                                                                    <span v-if="body[item[1]] != ''" :title="body[item[1]]" style="color:rgba(154, 154, 154, 1);font-size:12px">{{body[item[1]]}}</span>
                                                                    <span v-else>-</span>
                                                                </div>
                                                            </CCol>
                                                        </CRow>
                                                    </template>
                                                </template>
                                            </template>
                                            <template v-if="item == 'action'">
                                                <CButton @click="goEdit(id)" class="btn btn-edit">Edit</CButton>
                                            </template>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </CCol>
                </CRow>
            </div>
        </div>
        <div class="mobile-view">
            <CRow class="mt-3">
                <CCol sm="12">
                    <div>
                        <table class="table-responsive">
                            <thead>
                                <tr>
                                    <th @click="clickThead(index)" style="cursor:pointer" v-for="(item, index) in th" :key="index">
                                        <span v-if="item != 'Action'" style="float:left">{{item}}</span>
                                        <span v-if="item == 'Action'" style="float:right">{{item}}</span>
                                        <img v-if="item != 'Action'" :src="sortIcon[index]" width="16px" height="16px" style="float:right"/>
                                    </th>
                                </tr>
                            </thead>
                            <tbody v-if="data.length == 0">
                                <tr>
                                    <td class="text-center" colspan="5">
                                        {{errors}}
                                    </td>
                                </tr>
                            </tbody>
                            <tbody v-else>
                                <tr v-for="(body, id) in data" :key="id" @click="goEdit(id)" style="cursor:pointer">
                                    <td v-for="(item, index) in td" :key="index" :style="loadStyle(index)">
                                        <template v-if="item != 'action'">
                                            <template v-if="item[0].length == 1">
                                                <template v-if="item == 'hargaSatuan'">
                                                    {{rupiahMode(body[item])}}
                                                </template>
                                                <template v-else>
                                                    <template v-if="item == 'modified'">
                                                        <CRow v-if="body['modifiedBy'] != '' && body['modifiedAt'] != ''">
                                                            <CCol sm="12">
                                                                <span v-if="body['modifiedBy'] != ''">Oleh {{body['modifiedBy']}}</span>
                                                                <span v-if="body['modifiedBy'] == ''">-</span>
                                                            </CCol>
                                                            <CCol sm="12">
                                                                <span v-if="body['modifiedAt'] != ''">Pada {{body['modifiedAt']}}</span>
                                                                <span v-if="body['modifiedAt'] == ''">-</span>
                                                            </CCol>
                                                        </CRow>
                                                        <CRow v-else>
                                                            -
                                                        </CRow>
                                                    </template>
                                                    <template v-else>
                                                        <span v-if="body[item] != ''" :title="body[item]">{{body[item]}}</span>
                                                        <span v-else>-</span>
                                                    </template>
                                                </template>
                                            </template>
                                            <template v-if="item[0].length != 1">
                                                <template v-if="item[0] == 'tanggalMulaiKontrak'">
                                                    <span v-if="body[item[0]] != ''" :title="body[item[0]]">{{body[item[0]]}}</span><span v-else>-</span> - <span v-if="body[item[1]] != ''" :title="body[item[1]]">{{body[item[1]]}}</span><span v-else>-</span>
                                                </template>
                                                <template v-else>
                                                    <CRow>
                                                        <CCol sm="12">
                                                            <div class="ellps">
                                                                <span v-if="body[item[0]] != ''" :title="body[item[0]]">{{body[item[0]]}}</span>
                                                                <span v-else>-</span>
                                                            </div>
                                                        </CCol>
                                                        <CCol sm="12">
                                                            <div>
                                                                <span v-if="body[item[1]] != ''" :title="body[item[1]]" style="color:rgba(154, 154, 154, 1);font-size:12px">{{body[item[1]]}}</span>
                                                                <span v-else>-</span>
                                                            </div>
                                                        </CCol>
                                                    </CRow>
                                                </template>
                                            </template>
                                        </template>
                                        <template v-if="item == 'action'">
                                            <CButton @click="goEdit(id)" class="btn btn-edit">Edit</CButton>
                                        </template>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </CCol>
            </CRow>
        </div>
    </div>
    </template>
    
    <script>
    export default {
        props: ['data', 'th', 'td', 'styleTable', 'errors'],
        data() {
            return {
                sortIcon: [],
            }
        },
        mounted() {
            this.iconLoad('unsort', 'none')
        },
        watch: {
        },
        methods: {
            clickThead(index) {
                this.$emit('sort', index)
                this.iconLoad('sort', index)
            },
            goEdit(id) {
                this.$emit('edit', id)
            },
            loadStyle(index) {
                if(index == 6) {
                    return 'width:' + this.styleTable[index] + ';' + 'max-width:' + this.styleTable[index] + ';' + 'text-align:right'
                } else {
                    return 'width:' + this.styleTable[index] + ';' + 'max-width:' + this.styleTable[index]
                }
            },
            iconLoad(type, index) {
                this.sortIcon = []
                let length = this.th.length
                var i = 0
                if (type == 'sort') {
                    for(i=0;i<length;i++) {
                        let onPush = ''
                        if(index == i) {
                            onPush = require('../assets/menu/sort_normal.svg')
                        } else {
                            onPush = require('../assets/menu/sort_active.svg')
                        }
                        this.sortIcon.push(onPush)
                    }
                } else {
                    for(i=0;i<length;i++) {
                        let onPush = require('../assets/menu/sort_active.svg')
                        this.sortIcon.push(onPush)
                    }
                }
            },
            separatorDate(val) {
                let date = val.split(" ")[0]
                let time = val.split(" ")[1]
                return 'Every date at ' + date + ' on ' + time
            },
            rupiahMode(val) {
                var number_string = val.toString().replace(/[^,\d]/g, '')
                var split           = number_string.split(',')
                var sisa             = split[0].length % 3
                var rupiah             = split[0].substr(0, sisa)
                var ribuan             = split[0].substr(sisa).match(/\d{3}/gi)
                var prefix = "Rp. "
            
                // tambahkan titik jika yang di input sudah menjadi angka satuan ribuan
                if(ribuan){
                    var separator = sisa ? '.' : '';
                    rupiah += separator + ribuan.join('.');
                }
            
                rupiah = split[1] != undefined ? rupiah + ',' + split[1] : rupiah;
                let hasil = prefix == undefined ? rupiah : (rupiah ? 'Rp. ' + rupiah : '');
                return hasil
            }
        },
    }
    </script>
    
    <style scoped>
    @media only screen and (max-width:1278px) {
      .dekstop-view {
          display: none;
      }
    }
    @media only screen and (min-width:1279px) {
      .mobile-view {
          display: none;
      }
    }
    .ellps {
        overflow-x: hidden !important;
        text-overflow: ellipsis;
        white-space: nowrap;
    }
    table {
        width: 100%;
    }
    table thead tr {
        background-color: rgba(244, 244, 244, 1);
    }
    thead th {
        padding-top: 8px;
        padding-left: 8px;
        padding-right: 8px;
        padding-bottom: 8px;
    }
    tbody td {
        padding-top: 8px;
        padding-bottom: 8px;
        padding-left: 8px;
        padding-right: 8px;
    }
    td,th {
        /* overflow-x: hidden !important;
        text-overflow: ellipsis;
        white-space: nowrap; */
        border: 1px solid rgba(238, 238, 238, 1);
        font-size: 14px;
    }
    tr:nth-child(even) {
        background-color: rgba(252, 252, 252, 1);
    }
    div.sticky2 {
        position: -webkit-sticky;
        position: sticky;
        top: 105px;
        background-color: white;
        z-index: 1;
    }
    .content-sticky {
        background-color: white;
    }
    .btn-edit {
        border-radius: 4px;
        border: 1px solid rgba(154, 154, 154, 1);
        background-color: white;
        color: black;
        font-size: 14px;
        font-weight: 600;
        width: 80px;
        height: 32px;
        float:right;
    }
    .btn-edit:hover {
        border-radius: 4px;
        border: 1px solid rgba(154, 154, 154, 1);
        background-color: rgba(154, 154, 154, 1);
        color: white;
        font-size: 14px;
        font-weight: 600;
        width: 80px;
        height: 32px;
        float:right;
    }
    </style>